import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ReplyClock from './icon-reply-clock.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ReplyClock {...validProps} />;
}
SvgComponent.iconName = 'reply-clock';

/**
 * @deprecated This is a legacy icon
 */
export const ReplyClockIcon = svgIconWrapper(SvgComponent);
